module.exports = __webpack_public_path__ + "img/footer.bee1d6f8.png";